import { useState } from "react";
import emailjs from "@emailjs/browser";

const ContactForm = () => {
    const [formData, setFormData] = useState({
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
        category: "",
        message: "",
    });

    const [errors, setErrors] = useState({});
    const [submitError, setSubmitError] = useState("");
    const [successMessage, setSuccessMessage] = useState("");


    const validate = () => {
        let errors = {};
        if (!formData.firstName.trim()) errors.firstName = "First Name is required";
        if (!formData.lastName.trim()) errors.lastName = "Last Name is required";

        if (!formData.email.trim()) {
            errors.email = "Email is required";
        } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
            errors.email = "Invalid email format";
        }

        if (!formData.phone.trim()) {
            errors.phone = "Phone Number is required";
        } else if (!/^\d{10}$/.test(formData.phone)) {
            errors.phone = "Phone Number must be 10 digits";
        }

        if (!formData.category.trim()) errors.category = "Please select a category";

        if (!formData.message.trim()) errors.message = "Message is required";

        setErrors(errors);
        return Object.keys(errors).length === 0;
    };

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        setSubmitError(""); // Reset submit error on new attempt
        setSuccessMessage(""); // Reset success message on new attempt

        if (validate()) {
            emailjs
                .send(
                    process.env.REACT_APP_INFO_SERVICE_ID, // Replace with your EmailJS Service ID
                    process.env.REACT_APP_INFO_TEMPLATE_ID, // Replace with your EmailJS Template ID
                    formData,
                    process.env.REACT_APP_INFO_PUBLIC_ID // Replace with your EmailJS Public Key
                )
                .then((response) => {
                    alert("Email sent successfully!");
                    setSuccessMessage("Email sent successfully!");
                    setFormData({ firstName: "", lastName: "", email: "", phone: "", category: "", message: "" });
                })
                .catch((error) => {
                    setSubmitError("Failed to send email. Please try again later.");

                    console.log("EmailJS Error:", error);
                });
        }
    };


    return (
        <>
            <div className="container-fluid">

                <div className="row" style={{ paddingTop: '50px' }}>

                    <div className="col-md-6">

                        <div className="contacts-content">
                            <h1 >Fast-Track Your Journey to   <strong>Industry Leadership</strong></h1>
                            <div className="card-body no-borders">


                                <img src="assets/Logo White with Tagline.png" alt="Company Logo"  className="mr-3 pt-4 pb-5" />
                                <p className="card-text"> 
                                    387/1, Green Garden, L-block <br/>
                                    26th Street, Anna Nagar East, <br/>
                                    Chennai-600 102<br />
                                </p>
                                <p className="card-text"><i className="fas fa-phone-alt" style={{ color: "#44197e" }}></i>&nbsp;&nbsp;&nbsp; +919791293086 | +91 98403
                                    78352</p>
                                <p className="card-text"><i className="fas fa-envelope" style={{ color: "#44197e" }}></i>&nbsp;&nbsp;&nbsp; info@shanvatech.com |
                                    vishal@shanvatech.com</p>
                                <div class="row">
                                    <div class="col-lg-3 ">
                                        <p>follow us on :</p>
                                    </div>
                                    <div class="col-lg-9 ">
                                        <div className="social-icons" >
                                            <a href="https://www.facebook.com" target="_blank"
                                                className="btn btn-primary btn-sm mr-2">
                                                <i className="fab fa-facebook-f"></i>
                                            </a>
                                            <a href="https://www.twitter.com" target="_blank"
                                                className="btn btn-info btn-sm mr-2">
                                                <i className="fab fa-twitter"></i>
                                            </a>
                                            <a href="https://www.linkedin.com" target="_blank"
                                                className="btn btn-primary btn-sm mr-2">
                                                <i className="fab fa-linkedin-in"></i>
                                            </a>
                                            <a href="https://www.instagram.com" target="_blank"
                                                className="btn btn-danger btn-sm">
                                                <i className="fab fa-instagram"></i>
                                            </a>
                                        </div>
                                    </div>
                                </div>






                            </div>
                        </div>
                    </div>
                    <div className="col-md-6" >
                        <div className="" >

                            <div className="card-body no-borders">
                                <form onSubmit={handleSubmit}>
                                    <div className="form-row">
                                        <div className="form-group col-md-6">
                                            <label for="name">First name*</label>
                                            <input type="text" className="form-control" id="name" placeholder="Enter your Firstname" name="firstName" value={formData.firstName} onChange={handleChange} />
                                            {errors.firstName && <p style={{ color: "red" }}>{errors.firstName}</p>}
                                        </div>
                                        <div className="form-group col-md-6">
                                            <label for="email">Last Name*</label>
                                            <input type="text" className="form-control" id="email" placeholder="Enter your Last Name" name="lastName" value={formData.lastName} onChange={handleChange} />
                                            {errors.lastName && <p style={{ color: "red" }}>{errors.lastName}</p>}
                                        </div>
                                    </div>
                                    <div className="form-row">
                                        <div className="form-group col-md-6">
                                            <label for="phone">Email*</label>
                                            <input type="tel" className="form-control" id="phone"
                                                placeholder="Enter your Email" name="email" value={formData.email} onChange={handleChange} />
                                            {errors.email && <p style={{ color: "red" }}>{errors.email}</p>}
                                        </div>
                                        <div className="form-group col-md-6">
                                            <label for="phone">Phone</label>
                                            <input type="tel" className="form-control" id="phone"
                                                placeholder="Enter your phone number" name="phone" value={formData.phone} onChange={handleChange} />
                                            {errors.phone && <p style={{ color: "red" }}>{errors.phone}</p>}

                                        </div>
                                    </div>
                                    <div className="form-row">
                                        <div className="form-group col-md-12">
                                            <label for="phone">Category</label>
                                            <select className="form-control" name="category" value={formData.category} onChange={handleChange}>
                                                <option value="">Select a category</option>
                                                <option value="General Inquiry">General Inquiry</option>
                                                <option value="Support">Support</option>
                                                <option value="Feedback">Feedback</option>
                                            </select>
                                            {errors.category && <p style={{ color: "red" }}>{errors.category}</p>}
                                        </div>
                                    </div>
                                    <div className="form-row">
                                        <div className="form-group col-md-12">
                                            <label for="message">How Can i help you?</label>
                                            <textarea name="message" value={formData.message} onChange={handleChange} className="form-control" id="message" rows="3"
                                                placeholder="Your message"></textarea>
                                            {errors.message && <p style={{ color: "red" }}>{errors.message}</p>}
                                        </div>
                                    </div>
                                    <input class="form-group" type="checkbox" id="defaultCheck1" />
                                    <label class="form-check-label" for="defaultCheck1">
                                        &nbsp;I have read and agree to the Shanvatech Terms of Use and Privacy Policy.*
                                    </label>

                                    <p className="policy">shanvatech needs the contact information you provide to us to contact you about our products and services. You may unsubscribe from these communications at any time. For information on how to unsubscribe, as well as our privacy practices and commitment to protecting your privacy, please review our Privacy Policy.</p>

                                    <button type="submit" className="formSubmit">Send Message</button>
                                    {submitError && <p style={{ color: "red", marginTop: "10px" }}>{submitError}</p>}
                                    {successMessage && <p style={{ color: "green", marginTop: "10px" }}>{successMessage}</p>}
                                </form>




                            </div>
                        </div>
                    </div>




                </div>
            </div>
        </>
    )
}
export default ContactForm;